module.exports = __webpack_public_path__ + "img/logo-OST2.153e59b.png";